<template>
  <div class="card -rounded credit-consumption">
    <div class="header">
      <div class="description">
        <h2 class="title">Consumo de créditos</h2>
      </div>
    </div>
    <template v-if="!errors.unrecognized">
      <div class="body">
        <apex-chart
          type="area"
          height="350"
          :options="chartOptions"
          :series="series.chart"
        ></apex-chart>
      </div>
      <div class="footer">
        <ul class="numberStats">
          <li class="stat">
            <div class="statLeft">
              <div class="icon -primary"><ion-icon name="browsers-outline"></ion-icon></div>
            </div>
            <div class="statRight">
              <p class="title">Uso Hoje</p>
              <p class="value">R$ {{ series.creditsToday }}</p>
            </div>
          </li>
          <li class="stat">
            <div class="statLeft">
              <div class="icon -secondary"><ion-icon name="bar-chart-outline"></ion-icon></div>
            </div>
            <div class="statRight">
              <p class="title">Uso Últimos 30 dias</p>
              <p class="value">R$ {{ series.creditsLast30Days }}</p>
            </div>
          </li>
          <li class="stat">
            <div class="statLeft">
              <div class="icon -primary"><ion-icon name="analytics-outline"></ion-icon></div>
            </div>
            <div class="statRight">
              <p class="title">Consumo Total</p>
              <p class="value">{{ series.percentageUse }}%</p>
            </div>
          </li>
        </ul>
      </div>
    </template>
    <div class="body"  v-if="errors.unrecognized">
      <div class="alert -danger">
        <p>Ocorreu um erro ao tentar carregar os dados, por favor tente novamente.</p>
      </div>
    </div>
    <loader v-if="loading"/>
  </div>
</template>

<script>
import ApexChart from 'vue-apexcharts';
import Loader from '@/support/components/Loader.vue';
import currency from '@/support/filters/currency';

export default {
  name: 'CreditConsumption',

  data() {
    return {
      loading: false,

      errors: {
        unrecognized: false,
      },
    };
  },

  methods: {
    /**
     * Load the metrics
     *
     * @returns {Promise <void>}
     */
    async loadMetrics() {
      try {
        this.loading = true;
        this.resetErrors();

        await Promise.all([
          this.$store.dispatch('metrics/fetchCreditsUseToday'),
          this.$store.dispatch('metrics/fetchCreditsUseLast30Days'),
          this.$store.dispatch('metrics/fetchCreditsPercentageUse'),
          this.$store.dispatch('metrics/fetchCreditsUseLast30DaysChart'),
        ]);
      } catch {
        this.errors.unrecognized = true;
      } finally {
        this.loading = false;
      }
    },

    /**
     * Reset the errors page.
     */
    resetErrors() {
      this.errors.unrecognized = false;
    },
  },

  computed: {
    series() {
      return {
        chart: this.$store.state.metrics.creditsUseLast30DaysChart.series,
        percentageUse: this.$store.state.metrics.creditsPercentageUse,
        creditsToday: this.$store.state.metrics.creditsUseToday,
        creditsLast30Days: this.$store.state.metrics.creditsUseLast30Days,
      };
    },
    chartOptions() {
      return {
        legend: {
          show: true,
          itemMargin: {
            horizontal: 10,
            vertical: 10,
          },
        },
        chart: {
          height: window.screen.availHeight > 768 ? 350 : 300,
          type: 'area',
          toolbar: {
            show: false,
          },
        },
        colors: ['#7366ff', '#f73164', '#4C5EB3'],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: 'smooth',
        },
        grid: {
          show: false,
          padding: {
            left: 0,
            right: 0,
            bottom: -15,
            top: -40,
          },
        },
        yaxis: {
          low: 0,
          offsetX: 0,
          offsetY: 0,
          show: false,
          labels: {
            low: 0,
            offsetX: 0,
            show: false,
          },
          axisBorder: {
            low: 0,
            offsetX: 0,
            show: false,
          },
        },
        xaxis: {
          type: 'date',
          categories: this.$store.state.metrics.creditsUseLast30DaysChart.xAxis,
          labels: {
            show: false,
          },
        },
        tooltip: {
          x: {
            format: 'dd/MM/yy HH:mm',
          },
        },
      };
    },
  },

  mounted() {
    this.loadMetrics();
  },

  filters: {
    currency,
  },

  components: {
    ApexChart,
    Loader,
  },
};
</script>

<style lang="scss" scoped>
.credit-consumption {
  > .body {
    overflow: hidden;
  }

  > .footer {
    > .numberStats {
      @apply flex;
      @apply gap-4;
      @apply flex-wrap;

      @screen md {
        @apply flex-no-wrap;
      }

      > .stat {
        @apply w-full;
        @apply flex;
        @apply items-start;

        @screen md {
          @apply w-1/3;
        }

        > .statLeft {
          > .icon {
            width: 42px;
            height: 42px;
            @apply flex;
            @apply rounded-full;
            @apply items-center;
            @apply justify-center;
            @apply text-white;
            @apply text-xl;
            @apply mr-2;

            &.-primary {
              @apply bg-primary-500;
            }

            &.-secondary {
              background-color: #f73164;
            }
          }
        }

        > .statRight {
          @apply flex-1;

          > .title {
            @apply font-bold;
            @apply mb-0;
            @apply pb-0;
            @apply text-secondary-700;
            @apply text-sm;
          }

          > .value {
            @apply text-xs;
            @apply text-secondary-600;
          }
        }
      }
    }
  }
}
</style>
